import { render, staticRenderFns } from "./provide.vue?vue&type=template&id=4503749c&"
import script from "./provide.vue?vue&type=script&lang=js&"
export * from "./provide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports